import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import {
  BoldHeadingQuinary,
  BoldHeadingTertiary,
} from '@/shared/ui/typography';

export const Slide = styled.div`
  height: 220px;
  color: #333;

  @media (max-width: 768px) {
    height: 220px;
  }
`;

export const Wrapper = styled.div`
  ${WRAPPER};
  width: 100%;
  margin-top: 32px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
  }
`;

export const StyledPagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const Info = styled.div`
  border-radius: 8px;
  background: radial-gradient(
    60.63% 121.25% at 50% 0%,
    #131315 0%,
    #0a31ff 100%
  );
  padding: 4px 8px;
  display: inline-block;
  ${({ $secondaryTheme }) =>
    $secondaryTheme &&
    `
    background: radial-gradient(60.63% 121.25% at 50% 0%, #3D4A6F 0%, #2C3758 100%);
    position:relative;

  `}
`;

export const ButtonInfo = styled.div`
  border-radius: 10px;
  background: var(--6-a-7-ba-940, rgba(106, 123, 169, 0.4));
  box-shadow:
    0px 1px 1px 0px rgba(255, 255, 255, 0.08) inset,
    0px 1px 1px 0px rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

export const PromoIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

export const SlideContent = styled.div`
  padding: 18px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  padding-bottom: 20px;
  aspect-ratio: 16 / 9;
  height: 220px;
  width: 100%;

  @media (max-width: 768px) {
    border-radius: 0;
    aspect-ratio: 4 / 3;
    height: 420px;
    background-size: cover;
  }

  @media (max-width: 640px) {
    border-radius: 0;
    aspect-ratio: 4 / 3;
    height: 320px;
    background-size: cover;
  }

  @media (max-width: 560px) {
    border-radius: 0;
    aspect-ratio: 4 / 3;
    height: 280px;
    background-size: cover;
  }

  @media (max-width: 389px) {
    border-radius: 0;
    aspect-ratio: 4 / 3;
    height: 240px;
    background-size: cover;
  }

  @media (max-width: 320px) {
    border-radius: 0;
    aspect-ratio: 4 / 3;
    height: 220px;
    background-size: cover;
  }

  ${({ $imageUrl }) =>
    $imageUrl &&
    `
  background-image: url(${$imageUrl});  
`}

  ${({ $type, $locale }) =>
    $type === 'signup' &&
    `
  background-image: url(/images/background/banners/registration-banner-${$locale}.jpg);  

  @media (max-width: 768px) {
    background-image: url(/images/background/banners/registration-banner-${$locale}-mobile.jpg);  
  }
`} /* &:after {
  content:'';
  width:100%;
  height:100%;
  position:absolute;
  top:0;
  left:0;
  background: radial-gradient(79.87% 60.23% at 50% 28.18%, rgba(49, 79, 167, 0.00) 0%, rgba(0, 53, 114, 0.90) 100%);
} */
`;

export const SlideVideo = styled.video`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

export const Promocode = styled.div`
  color: var(--banner-image, #fff);
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Text shadow - a */
  text-shadow: 0.5px 0.5px 1px #000;
  font-family: Rubik;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 136%; /* 38.08px */
  position: absolute;
  right: 32px;
  top: 41%;
`;

export const WelcomeTitle = styled(BoldHeadingTertiary)`
  background: radial-gradient(50% 100% at 50% 0%, #ffe500 0%, #fca31e 100%);
  leading-trim: both;
  text-edge: cap;
  /* text-shadow: 0px 2px 0px #241421; */
  font-family: Onest;
  font-size: 35.505px;
  font-style: normal;
  font-weight: 900;
  line-height: 100%; /* 49.707px */
  text-transform: uppercase;
  background: var(
    --Gold-gradient,
    radial-gradient(49.58% 100% at 49.58% 0%, #ffe500 0%, #fca31e 100%)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const BoldHeadingQuinaryDynamic = styled(BoldHeadingQuinary)`
  text-shadow: 0px 1px 1px rgba(11, 21, 46, 0.5);
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;
